"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _excluded = ["active", "children", "onCloseTabs", "showCloseIcon"];
var _jsxFileName = "/codebuild/output/src7645329/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/TabPanel.js",
  _templateObject,
  _templateObject2;
function cov_ws92eby5() {
  var path = "/codebuild/output/src7645329/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/TabPanel.js";
  var hash = "953741532804a67729ac05e4324cad1acfeba992";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src7645329/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/TabPanel.js",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 24
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 15
        },
        end: {
          line: 9,
          column: 44
        }
      },
      "2": {
        start: {
          line: 10,
          column: 23
        },
        end: {
          line: 10,
          column: 79
        }
      },
      "3": {
        start: {
          line: 12,
          column: 30
        },
        end: {
          line: 12,
          column: 58
        }
      },
      "4": {
        start: {
          line: 18,
          column: 23
        },
        end: {
          line: 18,
          column: 54
        }
      },
      "5": {
        start: {
          line: 21,
          column: 18
        },
        end: {
          line: 29,
          column: 1
        }
      },
      "6": {
        start: {
          line: 33,
          column: 68
        },
        end: {
          line: 33,
          column: 73
        }
      },
      "7": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 49,
          column: 4
        }
      },
      "8": {
        start: {
          line: 52,
          column: 0
        },
        end: {
          line: 61,
          column: 2
        }
      },
      "9": {
        start: {
          line: 63,
          column: 0
        },
        end: {
          line: 67,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 9,
            column: 7
          }
        },
        loc: {
          start: {
            line: 9,
            column: 15
          },
          end: {
            line: 9,
            column: 44
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 10,
            column: 13
          },
          end: {
            line: 10,
            column: 14
          }
        },
        loc: {
          start: {
            line: 10,
            column: 23
          },
          end: {
            line: 10,
            column: 79
          }
        },
        line: 10
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 12,
            column: 21
          },
          end: {
            line: 12,
            column: 22
          }
        },
        loc: {
          start: {
            line: 12,
            column: 30
          },
          end: {
            line: 12,
            column: 58
          }
        },
        line: 12
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 18,
            column: 13
          },
          end: {
            line: 18,
            column: 14
          }
        },
        loc: {
          start: {
            line: 18,
            column: 23
          },
          end: {
            line: 18,
            column: 54
          }
        },
        line: 18
      },
      "4": {
        name: "TabPanel",
        decl: {
          start: {
            line: 32,
            column: 9
          },
          end: {
            line: 32,
            column: 17
          }
        },
        loc: {
          start: {
            line: 32,
            column: 25
          },
          end: {
            line: 50,
            column: 1
          }
        },
        line: 32
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 64,
            column: 15
          },
          end: {
            line: 64,
            column: 16
          }
        },
        loc: {
          start: {
            line: 64,
            column: 21
          },
          end: {
            line: 64,
            column: 23
          }
        },
        line: 64
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 23
          },
          end: {
            line: 10,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 10,
            column: 38
          },
          end: {
            line: 10,
            column: 62
          }
        }, {
          start: {
            line: 10,
            column: 65
          },
          end: {
            line: 10,
            column: 79
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 18,
            column: 23
          },
          end: {
            line: 18,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 18,
            column: 38
          },
          end: {
            line: 18,
            column: 45
          }
        }, {
          start: {
            line: 18,
            column: 48
          },
          end: {
            line: 18,
            column: 54
          }
        }],
        line: 18
      },
      "2": {
        loc: {
          start: {
            line: 37,
            column: 7
          },
          end: {
            line: 46,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 7
          },
          end: {
            line: 37,
            column: 20
          }
        }, {
          start: {
            line: 38,
            column: 8
          },
          end: {
            line: 45,
            column: 20
          }
        }],
        line: 37
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "953741532804a67729ac05e4324cad1acfeba992"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ws92eby5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ws92eby5();
var TabPanelWrapper = (cov_ws92eby5().s[0]++, _styledComponents.default.section.attrs({
  id: function id(props) {
    cov_ws92eby5().f[0]++;
    cov_ws92eby5().s[1]++;
    return "g-Tabs-panel-".concat(props.index);
  },
  className: function className(props) {
    cov_ws92eby5().f[1]++;
    cov_ws92eby5().s[2]++;
    return props.active ? (cov_ws92eby5().b[0][0]++, 'g-Tabs-panel is-active') : (cov_ws92eby5().b[0][1]++, 'g-Tabs-panel');
  },
  role: 'tabpanel',
  'aria-labelledby': function ariaLabelledby(props) {
    cov_ws92eby5().f[2]++;
    cov_ws92eby5().s[3]++;
    return "g-Tabs-link-".concat(props.index);
  }
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  box-sizing: border-box;\n  position: relative;\n  padding: 1rem 0;\n\n  display: ", ";\n"])), function (props) {
  cov_ws92eby5().f[3]++;
  cov_ws92eby5().s[4]++;
  return props.active ? (cov_ws92eby5().b[1][0]++, 'block') : (cov_ws92eby5().b[1][1]++, 'none');
}));
var CloseIcon = (cov_ws92eby5().s[5]++, _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  z-index: 1;\n  position: absolute;\n  right: 3px;\n  top: 18px;\n  &:hover {\n    cursor: pointer;\n  }\n"]))));

/** The tab panel, you should not use this component outside the tabs, it is the container of tab object */
function TabPanel(props) {
  cov_ws92eby5().f[4]++;
  var _ref = (cov_ws92eby5().s[6]++, props),
    active = _ref.active,
    children = _ref.children,
    onCloseTabs = _ref.onCloseTabs,
    showCloseIcon = _ref.showCloseIcon,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  cov_ws92eby5().s[7]++;
  return /*#__PURE__*/_react.default.createElement(TabPanelWrapper, (0, _extends2.default)({
    active: active
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 5
    }
  }), (cov_ws92eby5().b[2][0]++, showCloseIcon) && (cov_ws92eby5().b[2][1]++, /*#__PURE__*/_react.default.createElement(CloseIcon, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    iconName: "close",
    onClick: onCloseTabs,
    size: "small",
    iconColor: _stylingConstants.default.color.baseSubTitle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 11
    }
  }))), children);
}
cov_ws92eby5().s[8]++;
TabPanel.propTypes = {
  /** The content of a tab */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  /** Define if the tab is currently active, i.e. shown or hidden */
  active: _propTypes.default.bool,
  /** Method to close the tab panel */
  onCloseTabs: _propTypes.default.func,
  /** Boolean to show a close icon to close the panel */
  showCloseIcon: _propTypes.default.bool
};
cov_ws92eby5().s[9]++;
TabPanel.defaultProps = {
  onCloseTabs: function onCloseTabs() {
    cov_ws92eby5().f[5]++;
  },
  active: false,
  showCloseIcon: false
};
var _default = exports.default = TabPanel;